import { render, staticRenderFns } from "./confirm-c.vue?vue&type=template&id=144b0d5e&scoped=true&lang=pug&"
import script from "./confirm-c.vue?vue&type=script&lang=js&"
export * from "./confirm-c.vue?vue&type=script&lang=js&"
import style0 from "./confirm-c.vue?vue&type=style&index=0&id=144b0d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b0d5e",
  null
  
)

export default component.exports